import * as React from 'react';
import { Modal, Button } from 'roo-ui/components';
import { GlobalModalOptions } from 'store/modal/actions';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';

interface GlobalModalProps extends GlobalModalOptions {
  onClose: (...args: any) => any;
}

// TODO: Move <Modal /> into our codebase and fix
export const ModalWithZindex = styled(Modal)`
  .ModalOverlay {
    z-index: ${themeGet('zIndices.modalOverlay')};
  }
`;

const GlobalModal: React.FC<GlobalModalProps> = ({ isOpen, variant, header, body, onClose, button, onButtonClick }) => (
  <ModalWithZindex isOpen={isOpen} ariaHideApp={false} onRequestClose={onClose}>
    <Modal.header variant={variant}>{header}</Modal.header>
    <Modal.body>{body}</Modal.body>
    <Modal.footer>
      <Button variant="primary" onClick={onButtonClick}>
        {button}
      </Button>
    </Modal.footer>
  </ModalWithZindex>
);

export default GlobalModal;
